import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OverviewFieldValueComponent} from './overview-field-value/overview-field-value.component';
import {OverviewFieldLinkComponent} from './overview-field-link/overview-field-link.component';
import {SharedModule} from '../shared/shared.module';
import {ObjectOverviewFieldsComponent} from './object-overview-fields/object-overview-fields.component';
import {SearchTileOverviewFieldsComponent} from './search-tile-overview-fields/search-tile-overview-fields.component';
import {SearchColumnsOverviewFieldsComponent} from './search-columns-overview-fields/search-columns-overview-fields.component';
import { OverviewFieldComponent } from './overview-field/overview-field.component';
import { OverviewFieldItemComponent } from './overview-field-item/overview-field-item.component';
import { OverviewTitleComponent } from './overview-title/overview-title.component';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {MatListModule} from '@angular/material/list';
import {MatIcon} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';

@NgModule({
  declarations: [
    OverviewFieldValueComponent,
    OverviewFieldLinkComponent,
    ObjectOverviewFieldsComponent,
    SearchTileOverviewFieldsComponent,
    SearchColumnsOverviewFieldsComponent,
    OverviewFieldComponent,
    OverviewFieldItemComponent,
    OverviewTitleComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatButtonModule,
    MatMenuModule,
    MatListModule,
    MatIcon,
    MatTooltipModule
  ],
  exports: [
    OverviewFieldValueComponent,
    OverviewFieldLinkComponent,
    SearchColumnsOverviewFieldsComponent,
    SearchTileOverviewFieldsComponent,
    ObjectOverviewFieldsComponent,
    OverviewFieldComponent,
    OverviewFieldItemComponent,
    OverviewTitleComponent
  ]
})
export class OverviewFieldsModule {
}
